import ProjectsListView from "../views/Projects/ProjectsListView";
import ProjectDetailView from "../views/Projects/ProjectDetailView";
import ProjectSummaryView from "../views/Projects/ProjectSummaryView";
import ProjectSummaryEditView from "../views/Projects/ProjectSummaryEditView";
import ProjectWorkOrdersListView from "../views/Projects/ProjectWorkOrdersListView";
import WorkOrderDetailView from "../views/Projects/WorkOrderDetailView";
import WorkOrderSummaryView from "../views/Projects/WorkOrderSummaryView";
import WorkOrderSummaryEditView from "../views/Projects/WorkOrderSummaryEditView";
import BatchDetailView from "../views/Projects/BatchDetailView";
import WorkOrderBatchesListView from "../views/Projects/WorkOrderBatchesListView";
import ProjectBatchListView from "../views/Projects/ProjectBatchListView";
import WorkOrderQualityListView from "../views/Projects/WorkOrderQualityListView";
import ProjectQualityListView from "../views/Projects/ProjectQualityListView";
import ProjectShippingListView from "../views/Projects/ProjectShippingListView";
import BatchLabelView from "../views/Projects/BatchLabelView";
import ProjectCreate from "../views/Projects/ProjectCreate";

export default [
  {
    path: "/Projects",
    component: ProjectsListView,
    name: "ProjectsListView",
  },
  {
    path: "/Projects/Create",
    component: ProjectCreate,
    name: "ProjectCreateView"
  },
  {
    path: "/Projects/:id",
    component: ProjectDetailView,
    name: "ProjetDetailView",
    props: true,
    children: [
      {
        path: "Summary",
        component: ProjectSummaryView,
        name: "ProjectSummaryView",
        props: true
      },
      {
        path: "SummaryEdit",
        component: ProjectSummaryEditView,
        name: "ProjectSummaryEditView",
        props: true
      },
      {
        path: "Quality",
        component: ProjectQualityListView,
        name: "ProjectQualityListView",
        props: true
      },
      {
        path: "Shipping",
        component: ProjectShippingListView,
        name: "ProjectShippingListView",
        props: true
      },
      {
        path: "WorkOrders",
        name: "ProjectWorkOrderListView",
        component: ProjectWorkOrdersListView,
        props: true
      },
      {
        path: "WorkOrders/:workid",
        name: "WorkOrderDetailView",
        component: WorkOrderDetailView,
        props: true,
        children: [
          {
            path: "Summary",
            name: "WorkOrderSummaryView",
            component: WorkOrderSummaryView,
            props: true
          },
          {
            path: "SummaryEdit",
            name: "WorkOrderSummaryEditView",
            component: WorkOrderSummaryEditView,
            props: true
          },
          {
            path: "Batches",
            name: "WorkOrderBatchesListView",
            component: WorkOrderBatchesListView,
            props: true
          },
          {
            path: "Quality",
            name: "WorkOrderQualityListView",
            component: WorkOrderQualityListView,
            props: true
          }
        ]
      },
      {
        path: "Batches",
        name: "ProjectBatchListView",
        component: ProjectBatchListView,
        props: true
      },
      {
        path: "Batches/:batchid",
        name: "BatchDetailView",
        component: BatchDetailView,
        props: true,
      },
      {
        path: "Batches/:batchid/DymoLabel",
        name: "BatchLabelView",
        component: BatchLabelView,
        props: true
      }
    ]
  }
]